wv.THROTTLE_MOUSE_MOVE_RATE = 6;

export default class ThrottledMouseMoveTask {
    constructor() {
        this.taskManager = new TaskManager(1000 / wv.THROTTLE_MOUSE_MOVE_RATE);
        this.mouseEvent = null;
        this.noThrottle = false;
        this.callback = this.fireEvent.bind(this);
    }

    update(event) {
        this.mouseEvent = event;

        if (this.noThrottle) {
            this.callback();
        } else {
            this.taskManager.executeTask(this.callback);
        }
    }

    fireEvent() {
        document.dispatchEvent(new CustomEvent('throttled_pointermove', {
            detail: this.mouseEvent
        }));
    }
}
